import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import Plans from "@/pages/Plans";
import RVMotorhome from "@/pages/RVMotorhome";
import IotDataPools from "@/pages/IotDataPools";
import Solutions from "@/pages/Solutions";
import PrivateAPN from "@/pages/PrivateAPN";
import AndroidMDM from "@/pages/AndroidMDM";
import BYOC from "@/pages/BYOC";
import EnterpriseIoT from "@/pages/EnterpriseIoT";
import GovernmentPublicSafety from "@/pages/GovernmentPublicSafety";
import NetworkOutage from "@/pages/NetworkOutage";
import Resellers from "@/pages/Resellers";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Security from "@/pages/Security";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import { AuthProvider } from "@/context/AuthContext";

const PublicSite = ({ children }) => <Layout>{children}</Layout>;

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public site (with shared Layout) */}
            <Route path="/" element={<PublicSite><Home /></PublicSite>} />
            <Route path="/products" element={<PublicSite><Products /></PublicSite>} />
            <Route path="/plans" element={<PublicSite><Plans /></PublicSite>} />
            <Route path="/rv-motorhome" element={<PublicSite><RVMotorhome /></PublicSite>} />
            <Route path="/iot-data-pools" element={<PublicSite><IotDataPools /></PublicSite>} />
            <Route path="/solutions" element={<PublicSite><Solutions /></PublicSite>} />
            <Route path="/solutions/private-apn" element={<PublicSite><PrivateAPN /></PublicSite>} />
            <Route path="/solutions/android-mdm" element={<PublicSite><AndroidMDM /></PublicSite>} />
            <Route path="/solutions/byoc" element={<PublicSite><BYOC /></PublicSite>} />
            <Route path="/solutions/enterprise-iot" element={<PublicSite><EnterpriseIoT /></PublicSite>} />
            <Route path="/government-public-safety" element={<PublicSite><GovernmentPublicSafety /></PublicSite>} />
            <Route path="/network-outage" element={<PublicSite><NetworkOutage /></PublicSite>} />
            <Route path="/resellers" element={<PublicSite><Resellers /></PublicSite>} />
            <Route path="/about" element={<PublicSite><About /></PublicSite>} />
            <Route path="/contact" element={<PublicSite><Contact /></PublicSite>} />
            <Route path="/privacy" element={<PublicSite><Privacy /></PublicSite>} />
            <Route path="/security" element={<PublicSite><Security /></PublicSite>} />
            <Route path="/terms" element={<PublicSite><Terms /></PublicSite>} />

            {/* Admin (own layout) */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Admin />} />

            {/* 404 */}
            <Route path="*" element={<PublicSite><NotFound /></PublicSite>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
